// extracted by mini-css-extract-plugin
export default {"container":"productIcon_container__sQ+vT","icon":"productIcon_icon__0Z95x","percent":"productIcon_percent__Q6SgH"};